import {
  PaymentStatus,
  SerializableMap,
  SessionPaymentTransaction,
  TransactionAuthorizationResult,
  TransactionStatus,
} from '../models';

export const getTransactionStatus = (
  gpalStatus: PaymentStatus,
  isScheduledTransaction: boolean,
): TransactionStatus => {
  switch (gpalStatus) {
    case PaymentStatus.APPROVED:
    case PaymentStatus.SUCCESS:
      return isScheduledTransaction
        ? TransactionStatus.SCHEDULED
        : TransactionStatus.CAPTURED;
    case PaymentStatus.FAILED:
    case PaymentStatus.DECLINED:
      return TransactionStatus.FAILED;
    case PaymentStatus.IN_PROGRESS:
    case PaymentStatus.TIMEOUT:
      return TransactionStatus.PENDING;
    default:
      return TransactionStatus.UNKNOWN;
  }
};

export const getTransactionsWithUpdatedStatuses = (
  transactionAuthorizationResultMap: SerializableMap<TransactionAuthorizationResult>,
  sessionTransactions: SessionPaymentTransaction[],
): SessionPaymentTransaction[] => {
  const transactionReferences = Object.keys(transactionAuthorizationResultMap);

  transactionReferences.forEach((transactionReference) => {
    const updatedTransactionStatus = getTransactionStatus(
      transactionAuthorizationResultMap[transactionReference].gpalStatus,
      transactionAuthorizationResultMap[transactionReference]
        .isScheduledTransaction,
    );
    sessionTransactions.find(
      (transaction) =>
        transaction.transactionReference === transactionReference,
    ).status = updatedTransactionStatus as string;
  });

  return sessionTransactions;
};
